import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/articles/createItem";
import validator from "@validators/Clients/WhaleShark/articles/articles.validate";
import formMapper from "@mappers/Clients/WhaleShark/articles/ArticleItem.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
